<template>
  <div class="all">
    <MyHeader :menu-index="1" />
    <!--背景-->
    <div class="tpbg" id="a1">
      <img :src="fileServerUrl + 'assets/images/iTALLbj.jpg'" />
      <transition-group
        name="animate__animated animate__fadeInLeft"
        appear
        enter-active-class="animate__fadeInLeft"
        leave-active-class="animate__fadeInLeft"
      >
        <div class="tpbg-wz" key="1">
          <div style="margin-left: 5%; display: flex; flex-direction: column">
            <img
              :src="fileServerUrl + 'assets/images/tpbg-wz.png'"
              style="margin-bottom: 2%"
            />
            <span
              style="font-size: 0.35rem; font-weight: bold; color: #3b3e43"
              >{{ $t("CSTIS") }}</span
            >
          </div>

          <div
            style="
              color: red;
              font-size: 0.25rem;
              margin-left: -2%;
              margin-top: 5%;
            "
          >
            <span>“{{ $t("CSTIS_text") }}”</span>
          </div>
          <div class="tx ljgd">
            <span @click="more"
              >{{ $t("learn_more")
              }}<i
                class="iconfont icon-youjiantou"
                style="font-size: 0.15rem; margin-left: 5px"
              ></i
            ></span>
          </div>
        </div>
      </transition-group>
    </div>
    <!--总体-->
    <div class="main">
      <!--背景下的动画数字导航-->
      <div class="num-dh" v-if="numItemShow">
        <div class="num-item" v-for="(item, index) in numItemList" :key="index">
          <div class="num-item-sz">
            <animate-number
              :from="item.szFrom"
              :to="item.szTo"
              duration="2000"
            ></animate-number>
            <span>{{ item.fh }}</span>
          </div>
          <div class="num-item-wz">
            <span>{{ item.wz }}</span>
          </div>
        </div>
      </div>
      <!--itall信创-->
      <div class="xc" id="xc">
        <div
          class="ty-title xc-title"
          ref="huiyi"
          :class="{
            testhuiyi: true,
            testhuiyienter: aboutCoreShow,
            testhuiyileave: !aboutCoreShow,
          }"
        >
          <span>{{ $t("itall") }}</span>
          <div class="rhombus"></div>
        </div>

        <div
          class="ty-font"
          style="text-align: justify; line-height: 26px"
          ref="xcwz"
          :class="{
            testhuiyi: true,
            testhuiyienter: aboutxcwz,
            testhuiyileave: !aboutxcwz,
          }"
        >
          <p>
            {{ $t("itall_text1") }}
          </p>
          <p>
            {{ $t("itall_text2") }}
          </p>
        </div>
        <div
          class="xc-tp"
          ref="xctp"
          :class="{
            testhuiyi: true,
            testhuiyienter: aboutxctp,
            testhuiyileave: !aboutxctp,
          }"
        >
          <div class="xc-tp1">
            <img
              :src="fileServerUrl + 'assets/images/swiper13.jpg'"
              class="xffd"
            />
          </div>
          <div class="xc-tp1">
            <img
              :src="fileServerUrl + 'assets/images/swiper14.jpg'"
              class="xffd"
            />
          </div>
        </div>
      </div>
      <!--演讲嘉宾-->
      <div style="margin-top: 8%" class="ty-title xc-title">
        <span>{{ $t("guest_speakers") }}</span>
        <div class="rhombus"></div>
      </div>
      <!-- 本届 -->
      <div class="speaker2">
        <span>{{ $t("guest_speakers_text2") }}</span>
      </div>
      <div class="speaker-show" style="margin-top: 2%" ref="speakershow">
        <div class="speaker-row">
          <div class="rhombus-img2">
            <img :src="fileServerUrl + 'assets/jiabin/now1.png'" />
            <div class="speaker-info ty-font">
              <span class="info-name">{{ $t("guestnow1_1") }}</span>
              <span>{{ $t("guestnow1_2") }}</span>
              <span>{{ $t("guestnow1_3") }}</span>
            </div>
          </div>
          <div class="rhombus-img2">
            <img
              class="five-item-img"
              :src="fileServerUrl + 'assets/jiabin/now2.png'"
            />
            <div class="speaker-info ty-font">
              <span class="info-name">{{ $t("guestnow2_1") }}</span>
              <span>{{ $t("guestnow2_2") }}</span>
              <span>{{ $t("guestnow2_3") }}</span>
            </div>
          </div>
          <div class="rhombus-img2">
            <img
              class="five-item-img"
              :src="fileServerUrl + 'assets/jiabin/now3.png'"
            />
            <div class="speaker-info ty-font">
              <span class="info-name">{{ $t("guestnow3_1") }}</span>
              <span>{{ $t("guestnow3_2") }}</span>
              <span>{{ $t("guestnow3_3") }}</span>
            </div>
          </div>
          <div class="rhombus-img2">
            <img
              class="five-item-img"
              :src="fileServerUrl + 'assets/jiabin/now4.jpg'"
            />
            <div class="speaker-info ty-font">
              <span class="info-name">{{ $t("guestnow4_1") }}</span>
              <span>{{ $t("guestnow4_2") }}</span>
              <span>{{ $t("guestnow4_3") }}</span>
            </div>
          </div>
          <div class="rhombus-img2">
            <img
              class="five-item-img"
              :src="fileServerUrl + 'assets/jiabin/now5.jpg'"
            />
            <div class="speaker-info ty-font">
              <span class="info-name">{{ $t("guestnow5_1") }}</span>
              <span>{{ $t("guestnow5_2") }}</span>
              <span>{{ $t("guestnow5_3") }}</span>
            </div>
          </div>
        </div>
        <div class="speaker-row">
          <div class="rhombus-img2">
            <img :src="fileServerUrl + 'assets/jiabin/now6.jpg'" />
            <div class="speaker-info ty-font">
              <span class="info-name">{{ $t("guestnow6_1") }}</span>
              <span>{{ $t("guestnow6_2") }}</span>
              <span>{{ $t("guestnow6_3") }}</span>
            </div>
          </div>
          <div class="rhombus-img2">
            <img
              class="five-item-img"
              :src="fileServerUrl + 'assets/jiabin/now7.jpg'"
            />
            <div class="speaker-info ty-font">
              <span class="info-name">{{ $t("guestnow7_1") }}</span>
              <span>{{ $t("guestnow7_2") }}</span>
              <span>{{ $t("guestnow7_3") }}</span>
            </div>
          </div>
          <div class="rhombus-img2">
            <img
              class="five-item-img"
              :src="fileServerUrl + 'assets/jiabin/now8.png'"
            />
            <div class="speaker-info ty-font">
              <span class="info-name">{{ $t("guestnow8_1") }}</span>
              <span>{{ $t("guestnow8_2") }}</span>
              <span>{{ $t("guestnow8_3") }}</span>
            </div>
          </div>
          <div class="rhombus-img2">
            <img
              class="five-item-img"
              :src="fileServerUrl + 'assets/jiabin/now9.jpg'"
            />
            <div class="speaker-info ty-font">
              <span class="info-name">{{ $t("guestnow9_1") }}</span>
              <span>{{ $t("guestnow9_2") }}</span>
              <span>{{ $t("guestnow9_3") }}</span>
            </div>
          </div>
          <div class="rhombus-img2">
            <img
              class="five-item-img"
              :src="fileServerUrl + 'assets/jiabin/now10.jpg'"
            />
            <div class="speaker-info ty-font">
              <span class="info-name">{{ $t("guestnow10_1") }}</span>
              <span>{{ $t("guestnow10_2") }}</span>
              <span>{{ $t("guestnow10_3") }}</span>
            </div>
          </div>
        </div>
        <div class="speaker-row">
          <div class="rhombus-img2">
            <img :src="fileServerUrl + 'assets/jiabin/now11.jpg'" />
            <div class="speaker-info ty-font">
              <span class="info-name">{{ $t("guestnow11_1") }}</span>
              <span>{{ $t("guestnow11_2") }}</span>
              <span>{{ $t("guestnow11_3") }}</span>
            </div>
          </div>
          <div class="rhombus-img2">
            <img
              class="five-item-img"
              :src="fileServerUrl + 'assets/jiabin/now12.jpg'"
            />
            <div class="speaker-info ty-font">
              <span class="info-name">{{ $t("guestnow12_1") }}</span>
              <span>{{ $t("guestnow12_2") }}</span>
              <span>{{ $t("guestnow12_3") }}</span>
            </div>
          </div>
          <div class="rhombus-img2">
            <img
              class="five-item-img"
              :src="fileServerUrl + 'assets/jiabin/now13.jpg'"
            />
            <div class="speaker-info ty-font">
              <span class="info-name">{{ $t("guestnow13_1") }}</span>
              <span>{{ $t("guestnow13_2") }}</span>
              <span>{{ $t("guestnow13_3") }}</span>
            </div>
          </div>
          <div class="rhombus-img2">
            <img
              class="five-item-img"
              :src="fileServerUrl + 'assets/jiabin/now14.jpg'"
            />
            <div class="speaker-info ty-font">
              <span class="info-name">{{ $t("guestnow14_1") }}</span>
              <span>{{ $t("guestnow14_2") }}</span>
              <span>{{ $t("guestnow14_3") }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 往届 -->
      <div class="speaker" style="margin-top: 8%">
        <div
          ref="speaker"
          :class="{
            testhuiyi: true,
            testhuiyienter: aboutSpeaker,
            testhuiyileave: !aboutSpeaker,
          }"
        >
          <div class="speaker2">
            <span>{{ $t("guest_speakers_text") }}</span>
            <span class="kxz">2021-2023</span>
          </div>
        </div>

        <div
          class="speaker-show"
          style="margin-top: 2%"
          ref="speakershow"
          :class="{
            testhuiyi: true,
            testhuiyienter: aboutSpeakerShow,
            testhuiyileave: !aboutSpeakerShow,
          }"
        >
          <div class="speaker-row">
            <div class="rhombus-img">
              <img :src="fileServerUrl + 'assets/jiabin/custo-37.png'" />
              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest1") }}</span>
                <span>{{ $t("guest1_text1") }}</span>
                <span>{{ $t("guest1_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-32.png'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest2") }}</span>
                <span>{{ $t("guest2_text1") }}</span>
                <span>{{ $t("guest2_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-29.jpg'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest3") }}</span>
                <span>{{ $t("guest3_text1") }}</span>
                <span>{{ $t("guest3_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-35.png'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest4") }}</span>
                <span>{{ $t("guest4_text1") }}</span>
                <span>{{ $t("guest4_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-42.png'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest5") }}</span>
                <span>{{ $t("guest5_text1") }}</span>
                <span>{{ $t("guest5_text2") }}</span>
              </div>
            </div>
          </div>
          <div class="speaker-row">
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-39.png'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest6") }}</span>
                <span>{{ $t("guest6_text1") }}</span>
                <span>{{ $t("guest6_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-40.png'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest7") }}</span>
                <span>{{ $t("guest7_text1") }}</span>
                <span>{{ $t("guest7_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-43.png'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest8") }}</span>
                <span>{{ $t("guest8_text1") }}</span>
                <span>{{ $t("guest8_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-47.png'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest9") }}</span>
                <span>{{ $t("guest9_text1") }}</span>
                <span>{{ $t("guest9_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-38.png'"
              />
              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest10") }}</span>
                <span>{{ $t("guest10_text1") }}</span>
                <span>{{ $t("guest10_text2") }}</span>
              </div>
            </div>
          </div>
          <div class="speaker-row">
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-02.jpg'"
              />

              <!-- <div class="rhombus" style="bottom: 30%"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest11") }}</span>
                <span>{{ $t("guest11_text1") }}</span>
                <span>{{ $t("guest11_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-44.png'"
              />

              <!-- <div class="rhombus" style="bottom: 30%"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest12") }}</span>
                <span>{{ $t("guest12_text1") }}</span>
                <span>{{ $t("guest12_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-26.jpg'"
              />

              <!-- <div class="rhombus" style="bottom: 30%"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest13") }}</span>
                <span>{{ $t("guest13_text1") }}</span>
                <span>{{ $t("guest13_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-45.png'"
              />
              <!-- <div class="rhombus" style="bottom: 30%"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest14") }}</span>
                <span>{{ $t("guest14_text1") }}</span>
                <span>{{ $t("guest14_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-05.jpg'"
              />

              <!-- <div class="rhombus" style="bottom: 30%"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest15") }}</span>
                <span>{{ $t("guest15_text1") }}</span>
                <span>{{ $t("guest15_text2") }}</span>
              </div>
            </div>
          </div>
          <div class="speaker-row">
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-48.png'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest16") }}</span>
                <span>{{ $t("guest16_text1") }}</span>
                <span>{{ $t("guest16_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-49.png'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest17") }}</span>
                <span>{{ $t("guest17_text1") }}</span>
                <span>{{ $t("guest17_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-50.png'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest18") }}</span>
                <span>{{ $t("guest18_text1") }}</span>
                <span>{{ $t("guest18_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-51.png'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest19") }}</span>
                <span>{{ $t("guest19_text1") }}</span>
                <span>{{ $t("guest19_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-52.png'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest20") }}</span>
                <span>{{ $t("guest20_text1") }}</span>
                <span>{{ $t("guest20_text2") }}</span>
              </div>
            </div>
          </div>
          <div class="speaker-row">
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-53.png'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest21") }}</span>
                <span>{{ $t("guest21_text1") }}</span>
                <span>{{ $t("guest21_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-54.png'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest22") }}</span>
                <span>{{ $t("guest22_text1") }}</span>
                <span>{{ $t("guest22_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-55.png'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest23") }}</span>
                <span>{{ $t("guest23_text1") }}</span>
                <span>{{ $t("guest23_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-56-1.png'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest24") }}</span>
                <span>{{ $t("guest24_text1") }}</span>
                <span>{{ $t("guest24_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-46.png'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest25") }}</span>
                <span>{{ $t("guest25_text1") }}</span>
                <span>{{ $t("guest25_text2") }}</span>
              </div>
            </div>
          </div>
          <div class="speaker-row">
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-08.jpg'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest26") }}</span>
                <span>{{ $t("guest26_text1") }}</span>
                <span>{{ $t("guest26_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-22.jpg'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest27") }}</span>
                <span>{{ $t("guest27_text1") }}</span>
                <span>{{ $t("guest27_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-23.jpg'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest28") }}</span>
                <span>{{ $t("guest28_text1") }}</span>
                <span>{{ $t("guest28_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-28.jpg'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest29") }}</span>
                <span>{{ $t("guest29_text1") }}</span>
                <span>{{ $t("guest29_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-30.jpeg'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest30") }}</span>
                <span>{{ $t("guest30_text1") }}</span>
                <span>{{ $t("guest30_text2") }}</span>
              </div>
            </div>
          </div>
          <div class="speaker-row">
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-31-2.png'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest31") }}</span>
                <span>{{ $t("guest31_text1") }}</span>
                <span>{{ $t("guest31_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-36.png'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest32") }}</span>
                <span>{{ $t("guest32_text1") }}</span>
                <span>{{ $t("guest32_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-33.png'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest33") }}</span>
                <span>{{ $t("guest33_text1") }}</span>
                <span>{{ $t("guest33_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-34.png'"
              />

              <!-- <div class="rhombus"></div> -->
              <div class="speaker-info ty-font">
                <span class="info-name">{{ $t("guest34") }}</span>
                <span>{{ $t("guest34_text1") }}</span>
                <span>{{ $t("guest34_text2") }}</span>
              </div>
            </div>
            <div class="rhombus-img"></div>
          </div>
        </div>

        <!--<div class="speaker2" style="margin-top: 3%">
          <span>往届部分演讲嘉宾，排名不分先后</span>
          <span class="kxz">2021-2023</span>
        </div>
        <div class="speaker-show" style="margin-top: 2%">
          <div class="speaker-row">
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-12.jpg'"
              />

              <div class="rhombus"></div>
              <div class="speaker-info ty-font">
                <span class="info-name">刘赫伟</span>
                <span>云原生首席构架师</span>
                <span>华为</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-10.jpg'"
              />

              <div class="rhombus"></div>
              <div class="speaker-info ty-font">
                <span class="info-name">宗良</span>
                <span>首席研究员</span>
                <span>中国银行</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-11.jpg'"
              />

              <div class="rhombus"></div>
              <div class="speaker-info ty-font">
                <span class="info-name">吕晓琳</span>
                <span>科技开发中心</span>
                <span>副总工程师</span>
                <span>平安银行</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-15.jpg'"
              />

              <div class="rhombus"></div>
              <div class="speaker-info ty-font">
                <span class="info-name">万峰</span>
                <span>开放银行创新部总经理</span>
                <span>中原银行</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-14.jpg'"
              />

              <div class="rhombus"></div>
              <div class="speaker-info ty-font">
                <span class="info-name">高林林</span>
                <span>首席核赔</span>
                <span>泰康在线</span>
              </div>
            </div>
          </div>
          <div class="speaker-row">
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-20.jpg'"
              />

              <div class="rhombus"></div>
              <div class="speaker-info ty-font">
                <span class="info-name">张健广</span>
                <span>副总裁</span>
                <span>蓝凌软件</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-17.jpg'"
              />

              <div class="rhombus"></div>
              <div class="speaker-info ty-font">
                <span class="info-name">邱国涛</span>
                <span>总裁</span>
                <span>国成宝利融资</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-13.jpg'"
              />

              <div class="rhombus"></div>
              <div class="speaker-info ty-font">
                <span class="info-name">张海生</span>
                <span>首席风控官</span>
                <span>国联人寿</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-18.jpg'"
              />

              <div class="rhombus"></div>
              <div class="speaker-info ty-font">
                <span class="info-name">吕晔楠</span>
                <span>财产与意外险业务副总裁</span>
                <span>前海再保险</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-19.jpg'"
              />

              <div class="rhombus"></div>
              <div class="speaker-info ty-font">
                <span class="info-name">郑永强</span>
                <span>首席信息官</span>
                <span>三井住友保险（中国）</span>
              </div>
            </div>
          </div>
          <div class="speaker-row">
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-16.jpg'"
              />

              <div class="rhombus"></div>
              <div class="speaker-info ty-font">
                <span class="info-name">张萧萧</span>
                <span>信息技术规划部<br />副总经理</span>
                <span>中国再保险（集团）</span>
              </div>
            </div>
            <div class="rhombus-img">
              <img
                class="five-item-img"
                :src="fileServerUrl + 'assets/jiabin/custo-21.jpg'"
              />

              <div class="rhombus"></div>
              <div class="speaker-info ty-font">
                <span class="info-name">康德胜</span>
                <span>首席技术官</span>
                <span>众安保险</span>
              </div>
            </div>
            <div class="rhombus-img"></div>
            <div class="rhombus-img"></div>
            <div class="rhombus-img"></div>
          </div>
        </div> -->
      </div>
      <!--赞助商-->
      <div
        class="zzs"
        ref="zzs"
        :class="{
          testhuiyi: true,
          testhuiyienter: aboutzzs,
          testhuiyileave: !aboutzzs,
        }"
      >
        <div class="ty-title xc-title" style="margin-top: 8%">
          <span>{{ $t("sponsors") }}</span>
          <div class="rhombus"></div>
        </div>
        <div class="speaker2" style="margin-top: -2%">
          <span>{{ $t("sponsors_text") }}</span>
          <span class="kxz">2021-2023</span>
        </div>
        <div class="six-lb-1">
          <span
            class="iconfont six-lb-1-prev"
            @click="$refs.sixSwiper1.$swiper.slidePrev(1000, false)"
          >
            <i class="el-icon-arrow-left" style="color: #a2a9b6"></i>
          </span>
          <span
            class="iconfont six-lb-1-next"
            @click="$refs.sixSwiper1.$swiper.slideNext(1000, false)"
          >
            <i class="el-icon-arrow-right" style="color: #a2a9b6"></i>
          </span>
          <swiper
            class="six-lb-1-swiper"
            :options="swiperOptionsSix"
            ref="sixSwiper1"
          >
            <swiper-slide class="six-lb-1-slide">
              <img :src="fileServerUrl + 'assets/benjie/benjie18.png'" alt="" />
              <img :src="fileServerUrl + 'assets/benjie/benjie21.png'" alt="" />
              <img :src="fileServerUrl + 'assets/benjie/benjie19.png'" alt="" />
              <img :src="fileServerUrl + 'assets/benjie/benjie22.png'" alt="" />
              <img :src="fileServerUrl + 'assets/benjie/benjie17.png'" alt="" />

              <img :src="fileServerUrl + 'assets/benjie/benjie14.png'" alt="" />
              <img :src="fileServerUrl + 'assets/benjie/benjie23.png'" alt="" />
              <img
                :src="fileServerUrl + 'assets/benjie/benjie1-1.png'"
                alt=""
              />
              <img :src="fileServerUrl + 'assets/benjie/benjie2.png'" alt="" />
              <img :src="fileServerUrl + 'assets/benjie/benjie20.png'" alt="" />

              <img :src="fileServerUrl + 'assets/benjie/benjie10.png'" alt="" />

              <img :src="fileServerUrl + 'assets/benjie/benjie5.png'" alt="" />
              <img :src="fileServerUrl + 'assets/benjie/benjie6.png'" alt="" />
              <img :src="fileServerUrl + 'assets/benjie/benjie8.png'" alt="" />

              <img :src="fileServerUrl + 'assets/benjie/benjie24.png'" alt="" />

              <img :src="fileServerUrl + 'assets/benjie/benjie25.png'" alt="" />
              <img :src="fileServerUrl + 'assets/benjie/benjie26.png'" alt="" />
              <img :src="fileServerUrl + 'assets/benjie/benjie7.png'" alt="" />

              <img :src="fileServerUrl + 'assets/benjie/benjie9.png'" alt="" />
              <img :src="fileServerUrl + 'assets/benjie/benjie11.png'" alt="" />
            </swiper-slide>
            <swiper-slide class="six-lb-1-slide">
              <img :src="fileServerUrl + 'assets/benjie/benjie28.png'" alt="" />
              <img :src="fileServerUrl + 'assets/benjie/benjie13.png'" alt="" />
              <img :src="fileServerUrl + 'assets/benjie/benjie16.png'" alt="" />
            </swiper-slide>
          </swiper>
        </div>
        <!-- <div class="speaker2" style="margin-top: 3%">
          <span>往届部分赞助商，排名不分先后</span>
          <span class="kxz">2022-2021</span>
        </div>
        <div class="six-lb-1">
          <span
            class="iconfont six-lb-1-prev"
            @click="$refs.sixSwiper2.$swiper.slidePrev(1000, false)"
          >
            <i class="el-icon-arrow-left" style="color: #a2a9b6"></i>
          </span>

          <span
            class="iconfont six-lb-1-next"
            @click="$refs.sixSwiper2.$swiper.slideNext(1000, false)"
          >
            <i class="el-icon-arrow-right" style="color: #a2a9b6"></i>
          </span>
          <swiper
            class="six-lb-1-swiper"
            :options="swiperOptionsSix"
            ref="sixSwiper2"
          >
            <swiper-slide class="six-lb-1-slide">
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(60).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(61).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(62).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(63).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(64).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(65).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(66).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(67).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(68).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(69).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(10).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(11).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(12).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(13).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(14).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(15).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(16).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(17).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(18).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(19).png'"
                alt=""
              />
            </swiper-slide>
            <swiper-slide class="six-lb-1-slide">
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(20).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(21).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(27).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(28).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(29).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(30).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(31).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(33).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(34).png'"
                alt=""
              />
              <img
                :src="fileServerUrl + 'assets/wangjie/logo(35).png'"
                alt=""
              />
            </swiper-slide>
          </swiper>
        </div> -->
      </div>
      <!--会议亮点-->
      <div
        ref="hyld"
        :class="{
          testhuiyi: true,
          testhuiyienter: abouthyld,
          testhuiyileave: !abouthyld,
        }"
      >
        <div class="ty-title xc-title" style="margin-top: 8%">
          <span>{{ $t("conference_highlights") }}</span>
          <div class="rhombus"></div>
        </div>
        <div class="hyld">
          <div class="hyld-row">
            <div style="position: relative">
              <img :src="fileServerUrl + 'assets/Enhyrd01.jpg'" />
              <!--                            <div class="hyld-row-wz tx">战略会议</div>-->
            </div>

            <div style="position: relative">
              <img :src="fileServerUrl + 'assets/Enhyrd02.jpg'" />
              <!--                            <div class="hyld-row-wz tx">战略会议</div>-->
            </div>

            <div style="position: relative">
              <img :src="fileServerUrl + 'assets/Enhyrd03.jpg'" />
              <!--                            <div class="hyld-row-wz tx">战略会议</div>-->
            </div>
          </div>
          <div class="hyld-row" style="margin-top: 32px">
            <div style="position: relative">
              <img :src="fileServerUrl + 'assets/Enhyrd05.jpg'" />
              <!--                            <div class="hyld-row-wz tx">战略会议</div>-->
            </div>
            <div style="position: relative">
              <img :src="fileServerUrl + 'assets/Enhyrd06.jpg'" />
              <!--                            <div class="hyld-row-wz tx">战略会议</div>-->
            </div>
            <div style="position: relative">
              <img :src="fileServerUrl + 'assets/Enhyrd04.jpg'" />
              <!--                            <div class="hyld-row-wz tx">战略会议</div>-->
            </div>
          </div>
        </div>
      </div>

      <!--参与企业-->

      <div class="ty-title xc-title" style="margin-top: 8%">
        <span>{{ $t("participating_businesses") }}</span>
        <div class="rhombus"></div>
      </div>
      <gdt />
      <div style="height: 100px"></div>
    </div>
    <!-- 回到顶部-->
    <div class="hddb" v-show="showHddb">
      <!--  <span @click="counter1('#a1')" style="cursor: pointer;" >回到<br>顶部</span>-->
      <i
        @click="counter1('#a1')"
        class="iconfont icon-fanhuidingbu11"
        style="font-size: 0.28rem; color: red"
      ></i>
      <!--            <i @click="counter1('#a1')" class=" icon-huidaodingbu" >&#xe614;</i>-->
    </div>
    <myfoot />
  </div>
</template>

<script>
import MyHeader from "@/components/MyHeader";

import myfoot from "@/components/MyFoot";
import gdt from "@/components/Gdt";
import test from "@/views/test";
export default {
  name: "HomeView",
  components: { MyHeader, test, gdt, myfoot },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, true);
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  data() {
    return {
      fileServerUrl: fileServerUrl,
      showHddb: false,
      aboutCoreShow: false,
      aboutxcwz: false,
      aboutxctp: false,
      aboutSpeaker: false,
      aboutSpeakerShow: false,
      aboutzzs: false,
      abouthyld: false,

      swiperOptions: {
        //效果,特效  默认为"slide"（普通位移切换），还可设置为"fade"（淡入）、"cube"（方块）、"coverflow"（3d流）、"flip"（3d翻转）
        effect: "fade",
        // 无限循环
        loop: false,
        // 自动滚动
        // autoplay: true, //默认的效果
        // 个性化配置
        //autoResize : false,
        //自动调整大小
        slidesPerView: 1,

        autoplay: {
          delay: 6000, //间隔时长, 单位毫秒
          disableOnInteraction: true, //用户操作swiper后是否禁用自动滚动
        },
        // 分页器: 官方的API文档是 HTML版本的, 与 vue 中用法有细微差异
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //响应点击事件
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOptionsSix: {
        //效果,特效  默认为"slide"（普通位移切换），还可设置为"fade"（淡入）、"cube"（方块）、"coverflow"（3d流）、"flip"（3d翻转）
        // effect: "slide",
        effect: "slide",
        // 无限循环
        loop: true,
        // 自动滚动
        autoplay: false, //默认的效果
        // 个性化配置
        //autoResize : false,
        //自动调整大小
        slidesPerView: 1,
        // autoplay: {
        //     delay: 6000, //间隔时长, 单位毫秒
        //     disableOnInteraction: true, //用户操作swiper后是否禁用自动滚动
        // },
        // 分页器: 官方的API文档是 HTML版本的, 与 vue 中用法有细微差异
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //响应点击事件
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      numItemShow: false,
      numItemList: [
        {
          fh: "+",
          wz: "参会代表",
          szFrom: 3,
          szTo: 300,
        },
        {
          fh: "+",
          wz: "赞助商与展商",
          szFrom: 3,
          szTo: 40,
        },
        {
          fh: "+",
          wz: "演讲嘉宾",
          szFrom: 3,
          szTo: 35,
        },
        {
          fh: "+",
          wz: "时段",
          szFrom: 3,
          szTo: 28,
        },
        {
          fh: "+",
          wz: "专场",
          szFrom: 3,
          szTo: 3,
        },
      ],
    };
  },
  methods: {
    more() {
      document.querySelector("#xc").scrollIntoView(true);
    },
    counter1(item) {
      const returnEle = document.querySelector(item);
      if (!!returnEle) {
        returnEle.scrollIntoView(true);
      }
      document.querySelector(item).scrollIntoView(true);
      document.querySelector(item).scrollTop = 200;
      // this.scroll(document.getElementById(item).offsetTop - 15)
    },
    handleScroll(e) {
      this.currentScroll = window.pageYOffset; //表示当前滚动的位置
      // console.log(this.currentScroll)
      // this.currentScroll = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop //表示当前滚动的位置
      if (this.currentScroll >= this.$refs.huiyi.offsetTop - 750) {
        //当前滚动位置到达testref的时候，显示div（100作为调整用）
        this.aboutCoreShow = true;
      } else {
        this.aboutCoreShow = false;
      }
      if (this.currentScroll >= this.$refs.xcwz.offsetTop - 700) {
        //当前滚动位置到达testref的时候，显示div（100作为调整用）
        this.aboutxcwz = true;
      } else {
        this.aboutxcwz = false;
      }
      if (this.currentScroll >= this.$refs.xctp.offsetTop - 700) {
        //当前滚动位置到达testref的时候，显示div（100作为调整用）
        this.aboutxctp = true;
      } else {
        this.aboutxctp = false;
      }

      if (this.currentScroll >= this.$refs.speaker.offsetTop - 700) {
        //当前滚动位置到达testref的时候，显示div（100作为调整用）
        this.aboutSpeaker = true;
      } else {
        this.aboutSpeaker = false;
      }
      if (this.currentScroll >= this.$refs.speakershow.offsetTop - 700) {
        //当前滚动位置到达testref的时候，显示div（100作为调整用）
        this.aboutSpeakerShow = true;
      } else {
        this.aboutSpeakerShow = false;
      }
      if (this.currentScroll >= this.$refs.zzs.offsetTop - 700) {
        //当前滚动位置到达testref的时候，显示div（100作为调整用）
        this.aboutzzs = true;
      } else {
        this.aboutzzs = false;
      }
      if (this.currentScroll >= this.$refs.hyld.offsetTop - 700) {
        //当前滚动位置到达testref的时候，显示div（100作为调整用）
        this.abouthyld = true;
      } else {
        this.abouthyld = false;
      }

      this.numItemShow = this.currentScroll >= 200;
      this.showHddb = this.currentScroll >= 700;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/common.scss";
@import "@/assets/css/simpleAnimation.scss";
@import "animate.css";
@media all and (max-width: 900px) {
  .all {
    width: 100%;
    height: auto;
    font-family: weiruan;
  }

  .tpbg img {
    width: 100%;
    height: 417px;
    position: relative;
  }
}

.tpbg-wz {
  width: 260px;
  //border: 0.1px solid rebeccapurple;
  position: absolute;
  top: 25%;
  left: 13.5%;

  span {
    font-family: "阿里妈妈数黑体 Bold";
  }

  img {
    width: 130px;
    height: 45px;
  }

  .ljgd {
    background-color: red;
    width: 80px;
    height: 22px;
    border-radius: 15px;
    color: white;
    font-size: 0.13rem;
    margin-top: 7%;
    margin-left: 4%;
    cursor: pointer;
  }
}
.num-dh {
  width: 95%;
  height: 52px;
  //border: 0.1px solid darkcyan;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 5%;
  margin-left: 2%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.num-item {
  text-align: center;
  //border: 0.1px solid red;
  color: red;
}

.num-item-sz {
  width: 100%;
  font-weight: bold;
  font-size: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  //border: 0.1px solid rebeccapurple;
}

.num-item-wz {
  font-size: 0.1rem;
  color: #4b4b4b;
  //border: 0.1px solid darkorange;
}
//itall信创
.xc {
  margin-top: 8%;
  width: 100%;
  overflow-y: hidden;
}

.xc-tp {
  width: 100%;
  display: flex;
  margin-top: 5%;
  justify-content: space-between;
}

.xc-tp1 {
  width: 260px;
  height: 140px;
  overflow: hidden;
  //border: 0.1px solid red;
}

.xc-tp1 img {
  width: 100%;
  height: 100%;
}

.speaker {
  width: 100%;
}

.speaker2 {
  width: 50%;
  display: flex;
  flex-direction: column;
  font-size: 0.12rem;
  letter-spacing: 1px;
  font-weight: bold;
  color: red;
}
//演讲嘉宾
.speaker-show {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.speaker-row {
  width: 99%;
  display: flex;
  // justify-content: space-between;
  margin-top: 4%;
  margin-left: 4%;
  //border: 0.1px solid red;
}
.rhombus-img2 {
  width: 100px;
  position: relative;

  img {
    width: 80px;
    height: 115px;
    text-align: center;
    position: relative;
    // clip-path: polygon(20% 0%, 100% 0%, 80% 100%, 0% 100%);//图片倾斜效果
  }

  .speaker-info {
    margin-top: 5px;
    width: 80px;
    display: flex;

    //border: 0.1px solid darkorange;
    flex-direction: column;
  }

  .info-name {
    font-size: 0.12rem;
    font-weight: bold;
  }

  .rhombus {
    position: absolute;
    bottom: 35%;
    right: 29%;
    width: 15px;
    height: 15px;
    transform: rotateZ(110deg) skew(20deg, 10deg);
    background: #f60707;
  }
}
.rhombus-img {
  width: 100px;
  //border: 0.1px solid red;
  position: relative;

  img {
    object-fit: contain;
    width: 80px;
    height: 90px;
    text-align: center;
    position: relative;
    // clip-path: polygon(20% 0%, 100% 0%, 80% 100%, 0% 100%);//图片倾斜效果
  }

  .speaker-info {
    margin-top: 5px;
    width: 80px;
    display: flex;

    //border: 0.1px solid darkorange;
    flex-direction: column;
  }

  .info-name {
    font-size: 0.12rem;
    font-weight: bold;
  }

  .rhombus {
    position: absolute;
    bottom: 35%;
    right: 29%;
    width: 15px;
    height: 15px;
    transform: rotateZ(110deg) skew(20deg, 10deg);
    background: #f60707;
  }
}

/* .wrap{
        margin-top: 5%;
        margin-left: 5%;
        position:relative;
        width:80px;
        height:100px;
        background-color:rgb(255,255,255);
        box-shadow:0 0 0.5px rgb(0,0,0,.5);
        overflow:hidden;
        border-radius:0 0 0px 0px;
    }
    .box-top{
        position:relative;
        width:80px;
        height:60px;
        background-color:rgb(180,180,210);
        display:flex;
        justify-content:center;
        transition:.5s;
    }
    .box-top:after {
        content: '';
        width: 40px;
        //height: 40px;
        !*clip-path: polygon( 40% 30%,10% 0, 70% 0);*!
        clip-path: polygon( 0% 0%,0% 0, 0% 0);
        background-color: rgb(186, 180, 210);
        position:absolute;
        left:50%;
        transform:translate(-50%);
        bottom:-38px;
        z-index:999;
    }

    .image{
        position:absolute;
        top:5px;
        width:50px;
        height:50px;
        border: 0.5px solid rgb(140,140,170);
        transition:.5s;
        overflow: hidden;
    }
    .image img{
        width: 100%;
        height: 100%;
    }

    .box-bottom,.box-bottom2 {
        position: absolute;
        top: 63px;
        width: 80px;
        height: 30px;
        text-align: center;
        transition: .5s;
    }
    .box-bottom h2{
        display:block;
        color: #444444;
        font:200 0.11rem 'weiruan';
    }
    .box-bottom span {
        font: 100 5px 'weiruan';
    }
    .box-bottom h2::after {
        content: '';
        display: block;
        width: 50px;
        height: 1px;
        background-color: #f50909;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 4px);
    }
    .box-bottom2{
        top:300px;
        height:220px;

    }
    .box-bottom2 li{
        margin:5px;
        font:200 0.07rem 'weiruan';
        transition:.2s;
    }
    .wrap:hover .box-top{
        height:50px;
    }
    .wrap:hover .image {
        width: 35px;
        height: 35px;
        border-width: 3px;
        transform: translate(-20px, -5px);
    }
    .wrap:hover .box-bottom{
        top:300px;
    }
    .wrap:hover .box-bottom2 {
        top: 60px;
    }
    li:hover{
        color: rgb(100,100,160);
    }*/
//赞助商
.zzs {
  width: 100%;
  position: relative;
}
.six-lb-1-swiper {
  //margin: 10px 10px;

  margin-top: 7px;
}
.six-lb-1-prev {
  position: absolute;
  left: 2px;
  top: 20px;
  font-size: 20px;
  z-index: 2;
}
.six-lb-1-next {
  position: absolute;

  right: -6px;
  top: 20px;
  font-size: 20px;
  z-index: 2;
}
.six-lb-1-swiper img {
  width: 80px;
  height: 36px;
  margin-left: 26px;
  margin-bottom: 10px;
  //border: 1px solid red;
}
.six-lb-1-slide {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  margin-top: 1%;
}
.six-lb-1-slide img {
  transform: scale(1.01);
  transition: all 1s;
}
.six-lb-1-slide img:hover {
  transform: scale(1.1);
  transition: all 1s;
}
.six-lb-1 {
  position: relative;
  margin-left: -1%;
  margin-bottom: 5px;
}
//会议亮点
.hyld {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.hyld-row {
  width: 100%;

  //border: 0.1px solid red;
  display: flex;
  justify-content: space-between;
}

.hyld-row-wz {
  font-size: 0.1rem;
  color: #fff;
  position: absolute;
  width: 100%;
  height: 18px;
  bottom: 3%;
  border-radius: 0 0 5px 5px;
  background-color: rgba(227, 3, 3, 0.7);
}

.hyld-row img {
  object-fit: cover;
  width: 170px;
  height: 115px;
  border-radius: 5px;
}

.hddb {
  position: fixed;
  right: 3%;
  bottom: 10%;
  width: 25px;
  height: 25px;

  font-size: 15px;

  z-index: 1000;

  display: flex;

  cursor: pointer;
}
.hddb:hover {
  //background-color: #e7e8ec;
  opacity: 0.5;
}
</style>
